import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums';

const PostEstimations = (param: any) =>
    request({
        url: ApiURL.Command.PostEstimations,
        method: RequestType.POST,
        data: param,
    });

const PostCargoBacklogDay = (param: {
    date: Date | string;
    estimatedShippedDayFromBackoffice: number | string | null;
}) =>
    request({
        url: ApiURL.Command.PostCargoBacklogDay,
        method: RequestType.POST,
        data: param,
    });

const GetEstimationList = (params: { startDate: Date | string; endDate: Date | string }) =>
    request({
        url: ApiURL.Command.GetCargoEstimationList,
        method: RequestType.POST,
        data: params,
    });

const CargoEstimationCommand = {
    PostEstimations,
    PostCargoBacklogDay,
    GetEstimationList,
};

export default CargoEstimationCommand;
